module.exports = __webpack_public_path__ + "static/img/popup-swiper2.0546a42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup-swiper2.png
// module id = uMo6
// module chunks = 0